import { render, staticRenderFns } from "./OutStockOrderEdit.vue?vue&type=template&id=52b66e0c&scoped=true&"
import script from "./OutStockOrderEdit.vue?vue&type=script&lang=js&"
export * from "./OutStockOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./OutStockOrderEdit.vue?vue&type=style&index=0&id=52b66e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b66e0c",
  null
  
)

export default component.exports